import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Navbar.css";
import homeLogo from "../../assets2/La-capilla-Hotel.webp";

const LANGS = [
  { code: 'es', flag: '🇲🇽', label: 'ES' },
  { code: 'en', flag: '🇺🇸', label: 'EN' },
  { code: 'de', flag: '🇩🇪', label: 'DE' },
  { code: 'fr', flag: '🇫🇷', label: 'FR' },
];

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [langOpen, setLangOpen] = useState(false);
  const langRef = useRef(null);
  const { t, i18n } = useTranslation();
  const currentLang = LANGS.find(l => l.code === i18n.language) || LANGS[0];
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (langRef.current && !langRef.current.contains(e.target)) setLangOpen(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const isActive = (path) => location.pathname === path;

  const handleNavigation = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
    setIsMobileMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isMobileMenuOpen ? "menu-open" : ""}`}>
      <div className="navbar-container">
        <div className="navbar-logo" onClick={() => handleNavigation("/")}>
          <img src={homeLogo} alt="La Capilla Hotel" className="navbar-logo-img" />
        </div>

        <div className="navbar-right-controls">
          <div className="lang-switcher-nav" ref={langRef}>
            <button
              className="lang-switcher-btn"
              onClick={() => setLangOpen(prev => !prev)}
              aria-label="Change language"
            >
              <span className="lang-flag">{currentLang.flag}</span>
              <span className="lang-code">{currentLang.label}</span>
            </button>
            {langOpen && (
              <div className="lang-dropdown">
                {LANGS.map(l => (
                  <button
                    key={l.code}
                    className={`lang-option ${l.code === i18n.language ? 'active' : ''}`}
                    onClick={() => { i18n.changeLanguage(l.code); setLangOpen(false); }}
                  >
                    <span>{l.flag}</span>
                    <span>{l.label}</span>
                  </button>
                ))}
              </div>
            )}
          </div>

          <div 
            className={`hamburger ${isMobileMenuOpen ? "active" : ""}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

        <div className={`navbar-menu ${isMobileMenuOpen ? "open" : ""}`}>
          <div
            className={`nav-item ${isActive("/boutique") ? "active" : ""}`}
            onClick={() => handleNavigation("/boutique")}
          >
            <span className="nav-text">{t('navbar.boutique')}</span>
          </div>

           <div
            className={`nav-item ${isActive("/reservas") ? "active" : ""}`}
            onClick={() => handleNavigation("/reservas")}
          >
            <span className="nav-text">{t('navbar.casaHotel')}</span>
          </div>

          <div
            className={`nav-item ${isActive("/bodas") ? "active" : ""}`}
            onClick={() => handleNavigation("/bodas")}
          >
            <span className="nav-text">{t('navbar.bodas')}</span>
          </div>

          <div className="navbar-divider"></div>
          <div className="navbar-social">
            <a href="https://www.facebook.com/p/La-Capilla-Hotel-100064031587652/" target="_blank" rel="noopener noreferrer" className="social-link">
              <span className="social-icon" aria-hidden="true">f</span>
              <span className="social-text">{t('navbar.facebook')}</span>
            </a>
            <a href="https://www.instagram.com/lacapilla.hotel/" target="_blank" rel="noopener noreferrer" className="social-link">
              <span className="social-icon" aria-hidden="true">
                {/* Instagram SVG Icon */}
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <rect x="2" y="2" width="20" height="20" rx="5" stroke="#C9A961" strokeWidth="1.4" />
                  <path d="M12 7.2a4.8 4.8 0 100 9.6 4.8 4.8 0 000-9.6z" stroke="#C9A961" strokeWidth="1.4"/>
                  <circle cx="17.5" cy="6.5" r="0.8" fill="#C9A961" />
                </svg>
              </span>
              <span className="social-text">{t('navbar.instagram')}</span>
            </a>

            <div className="navbar-contact">
              <span className="contact-label">{t('navbar.lobby')}</span>
              <a className="contact-number" href="tel:+524181789398">{t('navbar.lobbyPhone')}</a>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
